var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMiLocal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.7857 17.1264V8.62643M2.21429 8.62643V17.1264M1 17.7803H18M10.7143 17.7803V11.5687C10.7143 11.3086 10.8102 11.0592 10.981 10.8752C11.1518 10.6913 11.3835 10.588 11.625 10.588H14.0536C14.2951 10.588 14.5268 10.6913 14.6975 10.8752C14.8683 11.0592 14.9643 11.3086 14.9643 11.5687V17.7803M14.2991 0.780273H4.70092C3.87406 0.780273 3.12728 1.27066 2.80625 2.02503L1.16317 5.88845C0.609911 7.18837 1.52859 8.66116 2.95386 8.70816H3.02975C4.22127 8.70816 5.18701 7.67917 5.18701 6.57376C5.18701 7.67712 6.15312 8.70816 7.34464 8.70816C8.53616 8.70816 9.5 7.75273 9.5 6.57376C9.5 7.67712 10.4657 8.70816 11.6573 8.70816C12.8488 8.70816 13.8149 7.75273 13.8149 6.57376C13.8149 7.75273 14.7806 8.70816 15.9721 8.70816H16.0461C17.4714 8.66035 18.3901 7.18756 17.8368 5.88845L16.1937 2.02503C15.8727 1.27066 15.1259 0.780273 14.2991 0.780273ZM4.94643 10.588H7.98214C8.22368 10.588 8.45532 10.6913 8.62612 10.8752C8.79691 11.0592 8.89286 11.3086 8.89286 11.5687V15.1649H4.03571V11.5687C4.03571 11.3086 4.13166 11.0592 4.30246 10.8752C4.47325 10.6913 4.70489 10.588 4.94643 10.588Z",
    stroke: "#656565",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMiLocal);
export default __webpack_public_path__ + "static/media/mi-local.9f3979e5008d7f86b8640837839199e0.svg";
export { ForwardRef as ReactComponent };